/*
 * @Author: your name
 * @Date: 2021-05-14 16:02:59
 * @LastEditTime: 2022-02-15 14:56:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/moduleDefine.js
 */
/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'
const routerComponents = {
  overtimeAudit: () =>
    import(/* webpackChunkName: "overtimeAudit" */ './overtime-audit/index.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/',
      component: BasicLayout,
      meta: {
        title: '质量检查',
        icon: 'chart'
      },
      children: [
        {
          path: 'CQSQ/CQSQList',
          component: dynamicWrapper(
            ['qc-overtime-manage/overtime-audit'],
            routerComponents.overtimeAudit
          ),
          meta: { title: '超期申请审核', noCache: true }
        }
      ]
    }
  ]
}
